import { client } from 'services/http';
import { fetchError, fetchSuccess } from './Common';
import { GET_USERS_LIST, SET_FITER_USER } from '@jumbo/constants/ActionTypes';

export const getUsersList = params => {
  return dispatch => {
    client
      .get(`/share/v3/users`, { params: { ...params, per_page: 50 } })
      .then(data => {
        if (data.status === 200 || data.status === 202) {
          dispatch(fetchSuccess());
          dispatch({ type: GET_USERS_LIST, payload: data.data });
        } else {
          dispatch(fetchError());
        }
      })
      .catch(error => {
        dispatch(fetchError(error?.response?.data?.base[0]));
      });
  };
};

export const setFilterUsers = params => {
  return dispatch => {
    dispatch({ type: SET_FITER_USER, payload: params });
  };
};
